import { Injectable } from '@angular/core';
import {
  SysDictInfoGetListByDictTypeRequest,
  SysDictInfoGetListByDictTypeResponse,
} from './model/models';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
@Injectable()
export class SysDictInfoSelectService extends BaseService {
  private getListByDictType_URL='api/lms/ucenter/sysDictInfo/getListByDictType';

  constructor(private client: E8HttpClient) {
    super();
  }
  getListByDictType(request: SysDictInfoGetListByDictTypeRequest, options?: C8HttpClientOptions): Promise<SysDictInfoGetListByDictTypeResponse> {
    return this.client.post(this.fUrl(this.getListByDictType_URL), request, options);
  }
}
